import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AccountService, Agent } from '@core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-verify-email',
  templateUrl: 'verify-email.page.html',
  styleUrls: ['verify-email.page.scss']
})
export class AccessVerifyEmailPage implements OnDestroy {

  user: Agent = null as any;
  xSub: Subscription;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private accountService: AccountService,
  ) {
    this.xSub = accountService.account.subscribe(user => {
      this.user = user;
    });
  }

  ngOnDestroy() {
    const { accountService } = this;
    accountService.setAccount(null);
    this.xSub.unsubscribe();
  }

}
